import {
  mapPermissionReponse,
  mapRoleCreatePayload,
  mapRoleListResponse,
  mapRoleResponse,
  mapRoleUpdatePayload,
} from '@/mappers/role.mapper';

import type { CreateRoleFormValues, UpdateRoleFormValues } from '@/schemas/role.schema';

import apiClient from '@/lib/api-client';
import { raiseAxiosErrorOrDefault } from '@/lib/error';

import type { Permission, Role } from '@/types/role.type';

export const fetchAllRoles = async (): Promise<Role[]> => {
  try {
    return await apiClient.get<Role[]>('/roles', mapRoleListResponse);
  } catch {
    return [];
  }
};

export const fetchRoleById = async (id: number): Promise<Role> => {
  try {
    const response = await apiClient.get<Role>(`/roles/${id}`, mapRoleResponse);
    return response;
  } catch (error) {
    raiseAxiosErrorOrDefault(error, 'Failed to fetch role');
  }
};

export const createRole = async (data: CreateRoleFormValues): Promise<Role> => {
  try {
    const response = await apiClient.post<Role>(
      '/roles',
      mapRoleCreatePayload(data),
      mapRoleResponse
    );
    return response;
  } catch (error) {
    raiseAxiosErrorOrDefault(error, 'Failed to create role');
  }
};

export const fetchAllPermissions = async (): Promise<Permission[]> => {
  try {
    const response = await apiClient.get<Permission[]>('/permissions', mapPermissionReponse);
    return response;
  } catch {
    return [];
  }
};

export const updateRole = async (id: number, data: UpdateRoleFormValues): Promise<void> => {
  try {
    await apiClient.patch<void>(`/roles/${id}`, mapRoleUpdatePayload(data));
  } catch (error) {
    raiseAxiosErrorOrDefault(error, 'Failed to update role');
  }
};

export const deleteRoleById = async (id: number): Promise<void> => {
  try {
    await apiClient.delete(`/roles/${id}`);
  } catch (e) {
    raiseAxiosErrorOrDefault(e, 'Failed to delete role');
  }
};
